/* ============
 * Bill Type Transformer
 * ============
 *
 * The transformer for the billTypes.
 */

import Transformer from './transformer';

export default class billTypeTransformer extends Transformer {

  static fetch(billTypes) {
    return {
      id: billTypes.id,
      name: billTypes.name,
    };
  }

  static send(billTypes) {
    return {
      id: billTypes.id,
      name: billTypes.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/billType.js